import * as React from 'react';

import { cn } from '../../../lib/utils';

// ─── Helpers ──────────────────────────────────────────────────────────────────

export function getScoreBadgeClass(score: number): string {
  if (score >= 80) return 'bg-green-100 text-green-700';
  if (score >= 50) return 'bg-yellow-100 text-yellow-700';
  return 'bg-red-100 text-red-700';
}

// ─── Component ────────────────────────────────────────────────────────────────

export interface ScoreBadgeProps {
  className?: string;
  score: number;
}

/**
 * Displays a geocoding score badge.
 *
 * By default the badge uses absolute positioning (for placement inside the
 * search input). Pass a `className` to override or extend styles — e.g. pass
 * `"relative"` to use the inline (non-absolute) variant next to coordinates.
 */
export function ScoreBadge({ className, score }: ScoreBadgeProps): React.JSX.Element {
  return (
    <span
      className={cn(
        'absolute right-3 top-1/2 -translate-y-1/2 text-xs font-semibold px-1.5 py-0.5 rounded',
        getScoreBadgeClass(score),
        className,
      )}
    >
      {score}%
    </span>
  );
}
